import KPageHeader from 'common/component/KPageHeader';
import KProTip from 'common/component/KProTip';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { Drawer, Popover } from 'antd';
import moment from 'moment';
import { EllipsisOutlined } from '@ant-design/icons';
import { KButton } from 'common/component/KButton';
import { useUser } from '../hooks/useUser';
import { SystemUserWrapper } from './user.style';
import UserTable from '../component/UserTable';
import { PopOverContent } from '../component/PopOverContent';
import ViewDrawer from '../component/ViewDrawer';
import { AllUsersTableColumn } from '../component/AllUserstableColumn';

interface Props {}

const user_type = ['All', 'Student', 'Manager', 'Teacher', 'Support', 'Parent'];

const UsersView: React.FC<Props> = () => {
  const [selectedUser, setSelectedUser] = React.useState('All');
  const [title, setTitle] = React.useState('');
  const [visibleDrawer, setVisibleDrawer] = React.useState(false);
  const [eachRow, setEachRow] = React.useState({});
  const {
    fetchStudent,
    fetchTeacher,
    fetchParent,
    fetchManager,
    fetchSupportPerson,
    fetchUsers,
  } = useUser();
  const users = useSelector((state: RootState) => state.user);
  const students = useSelector((state: RootState) => state.studentData);
  const teachers = useSelector((state: RootState) => state.teacher);
  const managers = useSelector((state: RootState) => state.manager);
  const parents = useSelector((state: RootState) => state.parent);
  const supportPerson = useSelector((state: RootState) => state.supportPerson);
  const [page, setPage] = React.useState({
    All: 1,
    Student: 1,
    Teacher: 1,
    Parent: 1,
  });
  const [limit, setLimit] = React.useState(10);
  const [reloadAfterDrawer, setReloadAfterDrawer] = React.useState(false);
  const [reload, setReload] = React.useState({
    All: true,
    Student: true,
    Manager: true,
    Teacher: true,
    Parent: true,
    Support: true,
  });

  const showDrawer = () => {
    setTitle('Add Student');
    setTimeout(() => {
      setVisibleDrawer(true);
    }, 0);
  };
  const onClose = () => {
    setVisibleDrawer(false);
  };

  const TableColumn = (role: String) => [
    {
      name: 'Username',
      selector: 'username',
      sortable: true,
      cell: (row: any) => <div>{row.__user__.username}</div>,
    },
    {
      name: 'Full Name',
      selector: 'fullName',
      sortable: true,
      cell: (row: any) => <div>{row.__user__.full_name}</div>,
    },
    {
      name: 'Email',
      selector: 'email',
      sortable: true,
      cell: (row: any) => <div>{row.__user__.email}</div>,
    },
    {
      name: 'Role',
      selector: 'role',
      sortable: true,
      cell: () => (
        <div>
          <div
            style={{
              background: 'var(--blue)',
              borderRadius: 40,
              padding: '5px 40px 5px 40px',
              color: 'var(--white)',
              fontSize: 'var(--font-sm)',
            }}
          >
            {role}
          </div>
        </div>
      ),
    },
    {
      name: 'Created At',
      selector: 'createdAt',
      sortable: true,
      cell: (row: any) => <div>{moment(row.__user__.created_at).format('Do MMM, YYYY')}</div>,
    },
    {
      name: 'Actions',
      selector: 'actions',
      sortable: true,
      cell: (row: any) => (
        <Popover
          content={
            <PopOverContent
              role={role}
              onSetTitle={setTitle}
              rowData={row}
              onSetRow={setEachRow}
              onSetVisibleDrawer={setVisibleDrawer}
            />
          }
          trigger="click"
          overlayStyle={{ padding: 0 }}
        >
          <EllipsisOutlined rotate={90} style={{ marginLeft: 15, fontSize: '20px' }} />
        </Popover>
      ),
    },
  ];

  const { All, Student, Teacher, Parent, Manager, Support } = reload;

  const memReload = useMemo(() => reload, [All, Student, Teacher, Parent, Manager, Support]);
  console.log(typeof memReload, memReload);
  console.log(selectedUser);

  // React.useEffect(() => {
  //   if (!visibleDrawer) {
  //     // setTitle('');
  //     console.log({ title });
  //   }
  // }, [visibleDrawer]);

  React.useEffect(() => {
    if (selectedUser === 'All' && memReload.All) {
      fetchUsers();
      setReload((prevReload) => ({ ...prevReload, All: false }));
    }
    if (selectedUser === 'Student' && memReload.Student) {
      fetchStudent(page.Student, limit);
      setReload((prevReload) => ({ ...prevReload, Student: false }));
    }
    if (selectedUser === 'Teacher' && memReload.Teacher) {
      fetchTeacher(page.Teacher, limit);
      setReload((prevReload) => ({ ...prevReload, Teacher: false }));
    }
    if (selectedUser === 'Manager' && memReload.Manager) {
      fetchManager();
      setReload((prevReload) => ({ ...prevReload, Manager: false }));
    }
    if (selectedUser === 'Support' && memReload.Support) {
      fetchSupportPerson();
      setReload((prevReload) => ({ ...prevReload, Support: false }));
    }
    if (selectedUser === 'Parent' && memReload.Parent) {
      fetchParent(page.Parent, limit);
      setReload((prevReload) => ({ ...prevReload, Parent: false }));
    }
  }, [selectedUser, memReload]);

  React.useEffect(() => {
    if (reloadAfterDrawer && selectedUser === 'Student') {
      fetchStudent(page.Student, limit);
      setReloadAfterDrawer(false);
    }
    if (reloadAfterDrawer && selectedUser === 'Teacher') {
      fetchTeacher(page.Teacher, limit);
      setReloadAfterDrawer(false);
    }
    if (reloadAfterDrawer && selectedUser === 'Parent') {
      fetchParent(page.Parent, limit);
      setReloadAfterDrawer(false);
    }
    if (reloadAfterDrawer && selectedUser === 'Manager') {
      fetchManager();
      setReloadAfterDrawer(false);
    }
    if (reloadAfterDrawer && selectedUser === 'Support') {
      fetchSupportPerson();
      setReloadAfterDrawer(false);
    }
  }, [reloadAfterDrawer]);

  React.useEffect(() => {
    if (selectedUser === 'Student') {
      fetchStudent(page.Student, limit);
    }
    if (selectedUser === 'Teacher') {
      fetchTeacher(page.Teacher, limit);
    }
    if (selectedUser === 'Parent') {
      fetchParent(page.Parent, limit);
    }
  }, [page, limit]);

  return (
    <SystemUserWrapper>
      {selectedUser === 'All' && <KPageHeader title="Sytstem Users" />}
      {selectedUser !== 'All' && (
        <KPageHeader
          title="Sytstem Users"
          rightButtonTitle="Add New"
          onRightButtonClick={showDrawer}
        />
      )}
      <Drawer
        width={705}
        title={<h2 style={{ fontWeight: 700 }}>{title}</h2>}
        placement="right"
        onClose={onClose}
        visible={visibleDrawer}
        closable={false}
      >
        <ViewDrawer
          title={title}
          setTitle={setTitle}
          eachRow={eachRow}
          setVisibleDrawer={setVisibleDrawer}
          setReloadAfterDrawer={setReloadAfterDrawer}
        />
      </Drawer>
      <KProTip
        title="Page Hint"
        description="This page is for viewing and managing all the users with various role that are currently in this system"
      />

      <section className="page-tabs">
        <div className="tabs">
          {user_type.map((item, index) => (
            <div
              key={index}
              onClick={() => {
                setSelectedUser(item);
                setTitle('Add ' + item);
              }}
              className={`page-tabs-item ${item === selectedUser ? 'active' : ''}`}
            >
              {item}
            </div>
          ))}
        </div>
        <KButton
          onClick={() => setReload((prevReload) => ({ ...prevReload, [selectedUser]: true }))}
        >
          Reload
        </KButton>
      </section>
      <section className="page-table">
        {selectedUser === 'All' && (
          <UserTable
            data={users}
            eachData={users.data}
            setLimit={setLimit}
            setPage={setPage}
            defaultPage={page.All}
            user={selectedUser}
            paginationServer={false}
            table={AllUsersTableColumn()}
          />
        )}
        {selectedUser === 'Student' && (
          <UserTable
            data={students}
            eachData={students.data.data}
            table={TableColumn(selectedUser)}
            setLimit={setLimit}
            setPage={setPage}
            defaultPage={page.Student}
            user={selectedUser}
            paginationServer={true}
          />
        )}
        {selectedUser === 'Teacher' && (
          <UserTable
            data={teachers}
            eachData={teachers.data.data}
            table={TableColumn(selectedUser)}
            setLimit={setLimit}
            setPage={setPage}
            defaultPage={page.Teacher}
            user={selectedUser}
            paginationServer={true}
          />
        )}
        {selectedUser === 'Manager' && (
          <UserTable
            data={managers}
            eachData={managers.data}
            table={TableColumn(selectedUser)}
            paginationServer={false}
          />
        )}
        {selectedUser === 'Support' && (
          <UserTable
            data={supportPerson}
            eachData={supportPerson.data}
            table={TableColumn(selectedUser)}
            paginationServer={false}
          />
        )}
        {selectedUser === 'Parent' && (
          <UserTable
            data={parents}
            eachData={parents.data.data}
            table={TableColumn(selectedUser)}
            setLimit={setLimit}
            setPage={setPage}
            defaultPage={page.Parent}
            user={selectedUser}
            paginationServer={true}
          />
        )}
      </section>
    </SystemUserWrapper>
  );
};

export default UsersView;
